export default {
  brandName: '晨昏线',
  mainTitleLine1: '机器人异构多机集群',
  mainTitleLine2: '作业管理平台',
  description: '统一调度，智能分配，让复杂的集群管理变得简单而优雅。',
  featureSafe: '安全可靠',
  featureStable: '高效稳定',
  featureSmart: '智能调度',
  welcomeTitle: '欢迎回来',
  welcomeSubtitle: '登录以继续使用平台服务',
  usernameLabel: '账号',
  usernamePlaceholder: '请输入您的账号',
  passwordLabel: '密码',
  passwordPlaceholder: '请输入您的密码',
  submit: '登录',
  submitting: '登录中...',
}
